export default {"src":"/_next/static/media/post-linkedin.e448f43b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};